function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Invoices"
}, /*#__PURE__*/React.createElement("title", null, "VF_invoices_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 0H35.4v283.5H248V92.1L141.7 0zm14.2 49.8L188.4 78h-32.5V49.8zM63.8 255.1V28.3h63.8v78h92.1v148.8H63.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.4 193h16.9c-2.1 16.3-14.2 26.7-33.6 26.7-17.3 0-32.1-8.2-36.9-25.8h-8.6v-9.1h7.1c0-1.3-.1-2.6-.1-4 0-1.1 0-2.1.1-3h-7.1v-9.1h8.4c4.5-18.2 19.4-26.9 37-26.9 19.2 0 31.6 10.2 33.7 27.1h-16.8c-1.3-7.3-7.2-12.9-17.4-12.9-8.1 0-15.1 3.7-18.4 12.6h26.8l-2.4 9.1H127c-.1 1-.1 2-.1 2.9 0 1.4.1 2.8.2 4h24.2l-2.4 9.1h-19.7c3.4 8.1 10.3 11.6 18 11.6 8.9.1 15.5-4.5 17.2-12.3z"
}))));